<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
    count: {
        default: 0,
        type: Number,
    },
    limit: {
        default: 500,
        type: Number,
    },
    marginBottom: {
        default: true,
        type: Boolean,
    },
});

const RADIUS = 40;
const circumference = 2 * Math.PI * RADIUS;

const characterCount = computed(() => {
    return props.limit - props.count;
});

const dashOffset = computed(() => {
    const progress = (props.limit - characterCount.value) / props.limit;
    return (progress * circumference);
});

const trackPath = computed(() => {
    const r = RADIUS
    return `
          M 50 50
          m 0 -${r}
          a ${r} ${r} 0 1 1 0 ${r * 2}
          a ${r} ${r} 0 1 1 0 -${r * 2}
          `
});
</script>

<template>
    <div
        :class="[
            'flex items-center justify-end gap-1',
            {
                '-mb-1': marginBottom,
            },
        ]"
    >
        <BaseText
            variant="xs-400"
            :class="[characterCount < 0 ? 'text-red-700' : 'text-gray-600']"
        >
            {{ characterCount }}
        </BaseText>
        <div class="block h-5 w-5">
            <ProgressRoot
                v-model="dashOffset"
                as-child
            >
                <svg
                    class="h-full w-full"
                    viewBox="0 0 100 100"
                >
                    <!-- Background circle -->
                    <path
                        :d="trackPath"
                        class="fill-none stroke-gray-300 stroke-[13px]"
                    />
                    <!-- Progress circle -->
                    <ProgressIndicator as-child>
                        <path
                            :d="trackPath"
                            class="fill-none stroke-green-900 stroke-[6px] transition-[stroke-dasharray,opacity] duration-700 data-[value='0']:opacity-0"
                            :style="{
                              'stroke-linecap': 'round',
                              'stroke-dasharray': `${dashOffset}px, ${circumference}px`,
                              'stroke-dashoffset': '0px',
                            }"
                        />
                    </ProgressIndicator>
                </svg>
            </ProgressRoot>
        </div>
    </div>
</template>
